import React from 'react';
import Types from 'prop-types';
export var PillNavigationContext = /*#__PURE__*/React.createContext({
  isPillNavigation: false
});
export var PillNavigationProvider = function PillNavigationProvider(_ref) {
  var children = _ref.children,
    pillNavigation = _ref.pillNavigation;
  return /*#__PURE__*/React.createElement(PillNavigationContext.Provider, {
    value: {
      isPillNavigation: pillNavigation
    }
  }, children);
};
export var usePillNavigation = function usePillNavigation() {
  var context = React.useContext(PillNavigationContext);
  if (context) {
    return context;
  }
  throw new Error('UsePillNavigation should be used within the pill navigation provider');
};
PillNavigationProvider.defaultProps = {
  children: null,
  pillNavigation: false
};